import { ValidLightingSetup } from '../Validation';
import { ArticleDefinitionMapper } from './ArticleDefinitionMapper';
import { articleService } from '../../services/articleService';

export class ValidLightingSetupMapper {
  public static toDomain = (dto: CoreServiceAPI.LightingRelatedArticleDto): ValidLightingSetup => ({
    articleId: dto.articleId,
    requiredLightingArticles: dto.requiredLightingArticles.map(articleDto =>
      articleService.instantiateRequiredArticle(ArticleDefinitionMapper.toDomain(articleDto))
    )
  });
}
